import React from 'react';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import * as actionTypes from '../../../../redux/actionTypes';
import AlertIcon from '../../../../_styles/images/AlertIcon.png';
import Close from '../../../../_styles/images/close-icon-green.svg';
import Callable from '../../../../shared/Callable';
import analyticsService from '../../../../shared/analytics/analytics-service';

function SecondaryCardNoticePopup(props) {


function manageCards() {
   props.close();
   props.updateSecondaryCardModal();
   analyticsService.analyticsProcessEvent({
    "event": "modal_click_generic",
    "context": {
      "event_action":  props.showCloseButton ? "close" : 'manage cards',
      "event_detail": {
          "modal": "subscription cost exceeds benefit card maximum modal"
      }  
    }
  });
  if(!props.showCloseButton){
    props.history.push({
        pathname: '/payment/summary/cards',
        state: { fromChangeSubscription: true, licenseNotification: props.licenseNotification }
      });
  }
}

function updateFedmilKeydown(e) {
    if (e.which === 13) {
        props.close();
    }
}

function closeModal() {
    props.updateSecondaryCardModal();
    props.close();
}

  return (
    <div className="charges-popup show" id='secondary-card-notice-popup' aria-live='polite' role='alert' aria-modal='true' tabIndex={0}>
    <div className='secondary-card-notice-container'>
        <div className="secondary-card-notice-modal-container">
            <div className='top-header'>
                <button
                    role='button'
                    className="close traditional"
                     onClick={() => closeModal()}
                     onKeyDown={updateFedmilKeydown}
                    tabIndex={0}
                    aria-label="Close popup"
                >
                    <img src={Close} alt='Close' />
                </button>

            </div>
            <div className="sp-header">

                <div className='header'>
                    <div className='van-image'>
                        <img src={AlertIcon} alt='van' />
                    </div>
                    <div className='heading'>
                    The subscription cost exceeds your maximum allowed benefit card coverage
                    </div>
                </div>
            </div>
            <div className='secondary-card-notice-popup-container'>
                <div className='content'>
                    <div className='first-section'>
                    To proceed, please add a secondary card or update your benefit amount to cover the cost of the subscription.
                    </div>
                </div>
                <div className='footer'>
                        <div className='help'>
                        Need help?
                        </div>
                        <div className="pre-text">
                        If you need assistance please contact 
                        </div>
                        <Callable className="greentext" phone="800 VAN 4 WORK" />
                      
                </div>
            </div>
            <div className='button-container'>
                <button tabIndex={0}  className="manage-cards" onClick={manageCards}>{props.showCloseButton ? "CLOSE" : "MANAGE CARDS"}</button>
            </div>

        </div>
    </div>
</div>
  );
}


export default connect(
  null,
  null
)(SecondaryCardNoticePopup);